<template>
  <div class="container">
    <div v-for="item in detail">
      <div class="text" v-if="item.key === 'text'">{{ item.value }}</div>
      <img class="img" v-if="item.key === 'img'" :src="item.value" />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { getStateApi } from '@/api/setting'

const { query } = useRoute()
const detail = ref([])

onMounted(async () => {
  const res = await getStateApi({ ruleType: query.type })
  detail.value = res.detail.filter(it => it.value)
  document.title = query.title || res.title
})
</script>

<style lang="less" scoped>
.container {
  background: white;
  .text {
    padding: 16px;
    font-size: 14px;
    color: #222222;
    line-height: 24px;
    word-break: break-all;
    white-space: pre-wrap;
  }

  .img {
    width: 100%;
  }
}
</style>
